<form [formGroup]="form.formGroup">

      <app-influx-frac-depth-base
        #influxFracDepthBase
        [form]="form"
        [influxDepthRange]="influxDepthRange"
        [tubulars]="tubulars"
        [fracPressures]="fracPressures"
        [userUnits]="userUnits"
        [currentString]="currentString"
        [fractureDepthDefault]="fractureDepthDefault"
        [smallestPipeId]="smallestPipeId"
    ></app-influx-frac-depth-base>

  <p-tabs value="0">
    <p-tablist>
      <p-tab value="0">Kick Parameters </p-tab>
      <p-tab value="1">Drill String</p-tab>
    </p-tablist>

    <p-tabpanels class="p-0">
      <p-tabpanel value="0">
        <div class="flex gap-2 flex-row m-2">
          <p-fieldset legend="Kick Parameters" class="w-1/2">
            <div class="flex flex-col space-y-2">
              <app-uom-input label="Influx Depth" [unitLabel]="userUnits.longLengths + ' MD'"
                [formControlName]="form.formControlNames.influxDepth" [control]="'influxDepth'"
                [default]="influxDepthRange.max" [min]="influxDepthRange.min" [max]="influxDepthRange.max" (focusout)="influxFracDepthBase.updateRangeAndFluidDensity()"
                title="Allowed range: {{ influxDepthRange.min }} - {{ influxDepthRange.max }} {{ userUnits.longLengths }}" />
              <app-uom-input label="Liquid Density" [unitLabel]="influxFracDepthBase.densityLabel"
                [formControlName]="form.formControlNames.liquidDensity" [control]="'liquidDensity'"
                [default]="influxFracDepthBase.liquidDensityDefault" [min]="influxFracDepthBase.liquidDensityValidation.min" [max]="influxFracDepthBase.liquidDensityValidation.max"
                title="Allowed range: {{ influxFracDepthBase.liquidDensityValidation.min }} - {{ influxFracDepthBase.liquidDensityValidation.max }} {{ influxFracDepthBase.volumeLabel }}" />
              <app-uom-input label="Kick Volume" [unitLabel]="influxFracDepthBase.volumeLabel"
                [formControlName]="form.formControlNames.kickVolume" [control]="'kickVolume'"
                [default]="influxFracDepthBase.kickVolumeDefault" [min]="influxFracDepthBase.kickVolumeValidation.min" [max]="influxFracDepthBase.kickVolumeValidation.max"
                title="Allowed range: {{ influxFracDepthBase.kickVolumeValidation.min }} - {{ influxFracDepthBase.kickVolumeValidation.max }} {{ influxFracDepthBase.volumeLabel }}" />
              <app-uom-input label="Kick Intensity" [unitLabel]="influxFracDepthBase.densityLabel"
              [formControlName]="form.formControlNames.kickIntensity" [control]="'kickIntensity'"
                [default]="influxFracDepthBase.kickIntensityDefault" [min]="influxFracDepthBase.kickIntensityValidation.min" [max]="influxFracDepthBase.kickIntensityValidation.max"
                title="Allowed range: {{ influxFracDepthBase.kickIntensityValidation.min }} - {{ influxFracDepthBase.kickIntensityValidation.max }} {{ influxFracDepthBase.densityLabel }}" />
              <app-uom-input label="Max Mud Weight" [unitLabel]="influxFracDepthBase.densityLabel"
                [formControlName]="form.formControlNames.maxMudWeight" [control]="'maxMudWeight'"
                [default]="nextStringMudWeight" [min]="influxFracDepthBase.maxMudWeightValidation.min" [max]="influxFracDepthBase.maxMudWeightValidation.max"
                title="Allowed range: {{ influxFracDepthBase.maxMudWeightValidation.min }} - {{ influxFracDepthBase.maxMudWeightValidation.max }} {{ influxFracDepthBase.densityLabel }}" />
            </div>
          </p-fieldset>

          <p-fieldset legend="Fracture Pressure" class="w-1/2">
            <div class="flex flex-col space-y-2">
              <app-uom-input label="Fracture Depth" [unitLabel]="userUnits.longLengths + ' MD'"
                [formControlName]="form.formControlNames.fractureDepth" [control]="'fractureDepth'"
                [default]="influxFracDepthBase.fractureDepthDefault" [min]="influxFracDepthBase.fracDepthsRange.min" [max]="influxFracDepthBase.fracDepthsRange.max"
                title="Allowed range: {{ influxFracDepthBase.fracDepthsRange.min }} - {{ influxFracDepthBase.fracDepthsRange.max }} {{ userUnits.longLengths }}"
                (focusout)="influxFracDepthBase.fractureDepthChange()" />

              <app-uom-input label="Fracture Gradient" [unitLabel]="influxFracDepthBase.densityLabel"
                [formControlName]="form.formControlNames.fractureGradient" [control]="'fractureGradient'"
                [default]="influxFracDepthBase.defaultFracGradient" [min]="influxFracDepthBase.fractureGradientValidation.min" [max]="influxFracDepthBase.fractureGradientValidation.max"
                title="Allowed range: {{ influxFracDepthBase.fractureGradientValidation.min }} - {{ influxFracDepthBase.fractureGradientValidation.max }} {{ influxFracDepthBase.densityLabel }}" 
                (focusout)="influxFracDepthBase.fractureGradientChange()"/>

              <app-uom-input label="Margin Of Error" [unitLabel]="influxFracDepthBase.densityLabel"
                [formControlName]="form.formControlNames.fractureMarginOfError" [control]="'fractureMarginOfError'"
                [default]="'0'" [min]="influxFracDepthBase.marginOfErrorValidation.min" [max]="influxFracDepthBase.marginOfErrorValidation.max"
                title="Allowed range: {{ influxFracDepthBase.marginOfErrorValidation.min }} - {{ influxFracDepthBase.marginOfErrorValidation.max }} {{ influxFracDepthBase.densityLabel }}" />
            </div>
          </p-fieldset>
        </div>
      </p-tabpanel>

      <p-tabpanel value="1">
        <div class="m-2">
          <app-uom-input label="Drill Pipe OD" [unitLabel]="userUnits.shortLengths"
            [formControlName]="form.formControlNames.drillPipeOd" [control]="'drillPipeOd'"
            [default]="influxFracDepthBase.defaultDrillPipeOd" title="Allowed range: 0 - {{ smallestPipeId }}" />
        </div>
      </p-tabpanel>

    </p-tabpanels>
  </p-tabs>
</form>